import { Check } from "lucide-react";
import { JOIN_PRESETS } from "@wedding/shared";
import type { JoinPreset } from "@wedding/shared";

interface PresetGridProps {
  selected: JoinPreset | undefined;
  onChange: (preset: JoinPreset) => void;
}

export function PresetGrid({ selected, onChange }: PresetGridProps) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
      {JOIN_PRESETS.map((preset) => {
        const isSelected = selected === preset.id;
        return (
          <button
            key={preset.id}
            onClick={() => onChange(preset.id as JoinPreset)}
            className={[
              "relative overflow-hidden rounded-2xl border-2 transition-all cursor-pointer text-left",
              isSelected
                ? "border-primary shadow-md shadow-primary/20"
                : "border-border hover:border-primary/40",
            ].join(" ")}
          >
            <div
              className="h-20 w-full"
              style={{
                background: `linear-gradient(135deg, ${preset.dark} 0%, ${preset.primary} 100%)`,
              }}
            />
            <div className="flex gap-1 px-3 py-2">
              <span className="h-3 w-3 rounded-full border border-white/20 shrink-0" style={{ background: preset.primary }} />
              <span className="h-3 w-3 rounded-full border border-white/20 shrink-0" style={{ background: preset.dark }} />
              <span className="h-3 w-3 rounded-full border shrink-0" style={{ background: preset.light }} />
            </div>
            <p className="px-3 pb-3 text-xs font-semibold">{preset.label}</p>
            {isSelected && (
              <span className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-primary">
                <Check className="h-3 w-3 text-white" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
